/**
 * 确认弹出框
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import Modal from 'boron/ScaleModal';

// let ua = window.navigator.userAgent;
// let isIOS = ua.match(/iphone|ipad|itouch/i);
function DialogHOC(ComposedComponent) {
	const style = {
		modalStyle: {
			width: '10rem',
			margin: '0 auto'
		},
		contentStyle: {
			width: '8.75rem',
			margin: '0 auto',
			borderRadius: '0.3125rem',
			backgroundColor: 'rgba(228,0,147,0.8)'
		},
		backdropStyle: {
			backgroundColor: "rgba(0,0,0, 0.85)"
		}
	}
	class Dialog  extends Component {
		static defaultProps = {
			onHide: function() {},
			onShow: function() {}
		}
		constructor(props){
			super(props);
			this.onHide = this.onHide.bind(this);
			this.onShow = this.onShow.bind(this);
		}

		componentWillMount () {
			this.status = 'cancel';
		}
		componentDidMount(){			this.showModal();
		}

		handleCancel = (e)=>{
			this.hideModal();
			
			this.status = 'cancel';
		}

		handleConfirm = (extra) =>{
			this.hideModal();

            this.extraParams = extra;
			this.status = 'confirm';
		}

		onHide() {
			if (typeof this.props.onHide =='function') {
				this.props.onHide();
			}

			if (this.status == 'cancel') {
				if (typeof this.props.onCancel == 'function') {
					this.props.onCancel();
				}
			} else if (this.status == 'confirm') {
				if (typeof this.props.onConfirm == 'function') {
					this.props.onConfirm(this.extraParams);
				}
			}
		}

		onShow() {
			if (typeof this.props.onShow =='function') {
				this.props.onShow();
			}
		}

		showModal(){
	        this.refs.modal.show();
	    }

	    hideModal(){
	        this.refs.modal.hide();
	    }

		render() {
			let modalStyle = style.modalStyle;
			let backdropStyle = style.backdropStyle;
			let contentStyle = style.contentStyle;
			let $footer;
			// if(isIOS){
			// 	modalStyle.position = 'absolute';

			// }
			
			if (this.props.modalStyle) {
                for (let style in this.props.modalStyle) {
                    modalStyle[style] = this.props.modalStyle[style];
                }
            }

            if (this.props.backdropStyle) {
                for (let style in this.props.backdropStyle) {
                    backdropStyle[style] = this.props.backdropStyle[style];
                }
            }

            if (this.props.contentStyle) {
                for (let style in this.props.contentStyle) {
                    contentStyle[style] = this.props.contentStyle[style];
                }
            }
            
			return (
				<Modal ref='modal' closeOnClick={this.props.closeOnClick} onHide={this.onHide} onShow={this.onShow} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle} className="popup-module">
					<ComposedComponent {...this.props} {...this.state} handleCancel={this.handleCancel} handleConfirm={this.handleConfirm}/>
				</Modal>
			);
		}
	}

	return Dialog;
}

module.exports = DialogHOC;



// WEBPACK FOOTER //
// ./js/popup/dialog-hoc.js